var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49965 0.578786L8.00727 2.62383L4.49965 4.66892L0.99258 2.62383L4.49965 0.578786ZM17.0074 2.62408L13.4999 4.66936L9.99254 2.62408L13.4999 0.5788L17.0074 2.62408ZM13.4999 9.91745L9.99255 7.87223L13.4999 5.82696L17.0073 7.87223L13.4999 9.91745ZM8.00727 7.87198L4.49965 9.91708L0.99258 7.87198L4.49965 5.82694L8.00727 7.87198ZM12.5074 11.3761L9.0003 13.4212L5.49268 11.3761L9.0003 9.33108L12.5074 11.3761Z",
    fill: "#0061FF",
    stroke: "#0061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.30711fd4c9077f50a663006c790bb3be.svg";
export { ForwardRef as ReactComponent };